import React, { useState, useEffect, useMemo } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import './App.css';
import homeIcon from './home.jpg';
import logo from './logo-DE.jpg';

const API_BASE_URL = 'https://mishrasoftwares-java-app.onrender.com';

const solarImages = [
  "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1521618755572-156ae0cdd74d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
];

const GenerateQuotation = ({ onLogout, loggedInUser }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    customerName: '',
    customerAddress: '',
    feAmount: 220000,
    vendorBank: ''
  });
  const [isGenerating, setIsGenerating] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsGenerating(true);
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/generate-pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Quotation_${formData.customerName.replace(/\s+/g, '_')}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        alert('Failed to generate quotation. Please try again.');
      }
    } catch (error) {
      console.error('Error generating quotation:', error);
      alert('An error occurred while generating the quotation.');
    } finally {
      setIsGenerating(false);
    }
  };

  const isFormValid = formData.customerName.trim() !== '' && formData.customerAddress.trim() !== '' && String(formData.feAmount).trim() !== '' && formData.vendorBank !== '';

  return (
    <div className="admin-page-container" style={{ padding: '2rem', minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
      <main style={{ background: 'white', padding: '2rem', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', maxWidth: '600px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h2 style={{ margin: '0', fontSize: '1.5rem', color: '#2c3e50' }}>Generate Quotation</h2>
            {loggedInUser && <p style={{ margin: '4px 0 0 0', color: '#6c757d', fontSize: '0.9rem' }}>Welcome, <strong style={{ color: '#2c3e50' }}>{loggedInUser}</strong>!</p>}
          </div>
          <div>
            <button onClick={() => navigate('/admin')} className="nav-btn" style={{ borderRadius: '0', marginRight: '10px' }}>Back</button>
            <button onClick={onLogout} className="nav-btn" style={{ borderRadius: '0', color: 'red' }}>Logout</button>
          </div>
        </div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Customer Name</label>
            <input type="text" name="customerName" value={formData.customerName} onChange={handleChange} required style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }} placeholder="Mukesh Das" />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Customer Address</label>
            <textarea name="customerAddress" value={formData.customerAddress} onChange={handleChange} required rows="2" style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', resize: 'none' }} placeholder="Belda, Tudigadia, Soro, Balasore, Odisha-756047" />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Amount (₹)</label>
            <input type="number" name="feAmount" value={formData.feAmount} onChange={handleChange} required style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }} placeholder="220000" />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Vendor Bank</label>
            <select name="vendorBank" value={formData.vendorBank} onChange={handleChange} required style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: 'white' }}>
              <option value="" disabled>Select Vendor Bank</option>
              <option value="State Bank of India">State Bank of India</option>
              <option value="Union Bank of India">Union Bank of India</option>
            </select>
          </div>
          <button type="submit" className="submit-btn" disabled={!isFormValid || isGenerating} style={{ marginTop: '10px', padding: '12px', backgroundColor: (isFormValid && !isGenerating) ? '#007bff' : '#ccc', color: 'white', border: 'none', borderRadius: '4px', cursor: (isFormValid && !isGenerating) ? 'pointer' : 'not-allowed', fontSize: '16px' }}>
            {isGenerating ? <div className="spinner-button" /> : 'Generate'}
          </button>
        </form>
      </main>
    </div>
  );
};

export const filterComplaintsByMobile = (complaints, searchTerm = '') => {
  const normalizedSearch = searchTerm.trim().toLowerCase();
  if (!normalizedSearch) return complaints;

  return complaints.filter((complaint) => {
    const searchableValues = [
      complaint.name,
      complaint.mobile,
      complaint.address,
      complaint.issue,
      complaint.date,
      complaint.status,
      complaint.remarks,
    ];

    return searchableValues.some((value) => {
      const normalizedValue = String(value || '').trim().toLowerCase();
      return normalizedValue.includes(normalizedSearch);
    });
  });
};

const AdminPage = ({ contacts, complaints, onLogout, fetchContacts, fetchComplaints, loggedInUser, onOpenComplaintModal }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('contacts');
  const [currentPage, setCurrentPage] = useState(1);
  const [complaintSearchMobile, setComplaintSearchMobile] = useState('');
  const [isRefreshingComplaints, setIsRefreshingComplaints] = useState(false);
  const itemsPerPage = 10;

  const handleComplaintSearchChange = (e) => {
    setComplaintSearchMobile(e.target.value);
  };

  const filteredComplaints = useMemo(() => {
    return activeTab === 'complaints'
      ? filterComplaintsByMobile(complaints, complaintSearchMobile)
      : complaints;
  }, [activeTab, complaints, complaintSearchMobile]);

  const sortedComplaints = useMemo(() => {
    if (activeTab !== 'complaints') return filteredComplaints;

    return [...filteredComplaints].sort((a, b) => {
      const statusA = String(a.status || 'pending').toLowerCase();
      const statusB = String(b.status || 'pending').toLowerCase();
      if (statusA === statusB) return 0;
      if (statusA === 'pending') return -1;
      if (statusB === 'pending') return 1;
      return statusA.localeCompare(statusB);
    });
  }, [activeTab, filteredComplaints]);

  const currentData = useMemo(() => {
    return activeTab === 'contacts' ? contacts : sortedComplaints;
  }, [activeTab, contacts, sortedComplaints]);

  const pendingComplaintsCount = useMemo(() => {
    return complaints.filter((complaint) => String(complaint.status || 'pending').toLowerCase() === 'pending').length;
  }, [complaints]);

  const completedComplaintsCount = useMemo(() => {
    return complaints.filter((complaint) => String(complaint.status || 'pending').toLowerCase() === 'resolved').length;
  }, [complaints]);

  // Reset to page 1 when the tab, data, or search changes
  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, contacts, complaints, complaintSearchMobile]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = currentData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(currentData.length / itemsPerPage);

  const [editedComplaints, setEditedComplaints] = useState({});

  const handleEditChange = (complaintId, field, value) => {
    setEditedComplaints(prev => ({
      ...prev,
      [complaintId]: {
        ...prev[complaintId],
        [field]: value
      }
    }));
  };

  const handleSaveComplaint = async (complaint, uniqueId) => {
    const edited = editedComplaints[uniqueId];
    if (!edited) return;

    const newStatus = edited.status !== undefined ? edited.status : (complaint.status || 'pending');
    const newRemarks = edited.remarks !== undefined ? edited.remarks : (complaint.remarks || '');

    if (!complaint.mobile) {
      alert('Cannot save: Complaint mobile number is missing from the server data.');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/update-complaints`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          ...complaint, 
          status: newStatus, 
          remarks: newRemarks 
        }),
      });
      if (response.ok) {
        setEditedComplaints(prev => {
          const next = { ...prev };
          delete next[uniqueId];
          return next;
        });
        fetchComplaints(); // Refresh the table automatically
      } else {
        alert('Failed to update complaint.');
      }
    } catch (error) {
      console.error('Error updating complaint:', error);
      alert('An error occurred while updating the complaint.');
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  const handleRefreshData = async () => {
    setActiveTab('complaints');
    setComplaintSearchMobile('');
    setEditedComplaints({});
    setIsRefreshingComplaints(true);

    try {
      await Promise.all([fetchContacts(), fetchComplaints()]);
    } finally {
      setIsRefreshingComplaints(false);
    }
  };

  const paginationButtonStyle = {
    marginLeft: '8px',
    padding: '8px 12px',
    border: '1px solid #ddd',
    background: 'white',
    cursor: 'pointer',
    borderRadius: '4px'
  };

  const disabledButtonStyle = {
    ...paginationButtonStyle,
    cursor: 'not-allowed',
    opacity: 0.5
  };

  return (
    <div className="admin-page-container" style={{ padding: '2rem', minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
      <main style={{ background: 'white', padding: '2rem', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h2 style={{ margin: '0', fontSize: '1.5rem', color: '#2c3e50' }}>Admin Dashboard</h2>
            {loggedInUser && <p style={{ margin: '4px 0 0 0', color: '#6c757d', fontSize: '0.9rem' }}>Welcome, <strong style={{ color: '#2c3e50' }}>{loggedInUser}</strong>!</p>}
          </div>
          <div>
            <button onClick={onOpenComplaintModal} className="nav-btn" style={{ borderRadius: '0', marginRight: '10px', color: 'red', borderColor: 'red' }}>Register Complaint</button>
            <button onClick={() => navigate('/generate-quotation')} className="nav-btn" style={{ borderRadius: '0', marginRight: '10px' }}>Generate Quotation</button>
            <button onClick={handleRefreshData} disabled={isRefreshingComplaints} className="nav-btn" style={{ borderRadius: '0', marginRight: '10px', opacity: isRefreshingComplaints ? 0.7 : 1 }}>
              {isRefreshingComplaints ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}><span className="spinner-button" /> Refreshing...</span> : 'Refresh Data'}
            </button>
            <button onClick={onLogout} className="nav-btn" style={{ borderRadius: '0', color: 'red' }}>Logout</button>
          </div>
        </div>

        <div style={{ marginTop: '20px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <div>
            <button 
              onClick={() => setActiveTab('contacts')} 
              style={{ padding: '10px 20px', cursor: 'pointer', backgroundColor: activeTab === 'contacts' ? '#007bff' : '#f4f7f6', color: activeTab === 'contacts' ? 'white' : 'black', border: '1px solid #ddd', borderRadius: '4px 0 0 4px', fontWeight: activeTab === 'contacts' ? 'bold' : 'normal' }}
            >
              Contact Requests
            </button>
            <button 
              onClick={() => setActiveTab('complaints')} 
              style={{ padding: '10px 20px', cursor: 'pointer', backgroundColor: activeTab === 'complaints' ? '#007bff' : '#f4f7f6', color: activeTab === 'complaints' ? 'white' : 'black', border: '1px solid #ddd', borderRadius: '0 4px 4px 0', borderLeft: 'none', fontWeight: activeTab === 'complaints' ? 'bold' : 'normal' }}
            >
              Complaints
            </button>
          </div>
          {activeTab === 'complaints' && (
            <>
              <input
                type="text"
                value={complaintSearchMobile}
                onChange={handleComplaintSearchChange}
                placeholder="Search complaints by any detail"
                style={{ padding: '10px 12px', border: '1px solid #ddd', borderRadius: '4px', minWidth: '240px' }}
              />
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                <span className="blink-text-red" style={{ fontSize: '0.95rem', color: '#dc3545', fontWeight: 'bold' }}>
                  Pending Issues: {pendingComplaintsCount}
                </span>
                <span className="blink-text-red" style={{ fontSize: '0.95rem', color: '#198754', fontWeight: 'bold' }}>
                  Completed Issues: {completedComplaintsCount}
                </span>
              </div>
            </>
          )}
        </div>

        {activeTab === 'contacts' && (
          <>
            {contacts.length > 0 ? (
              <table className="contacts-table" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                <thead>
                  <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'left' }}>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Name</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Mobile</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Address</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>City</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Roof Type</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((contact, index) => {
                    return (
                      <tr key={index} style={{ borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{contact.name}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{contact.mobile}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{contact.address}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{contact.city}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{contact.roofType}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                          {contact.date || ''}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <p>No contact requests received yet.</p>
            )}
          </>
        )}

        {activeTab === 'complaints' && (
          <>
            {isRefreshingComplaints && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', color: '#007bff', fontWeight: 'bold' }}>
                <span className="spinner-button" />
                Loading complaints...
              </div>
            )}
            {complaints.length > 0 ? (
              currentData.length > 0 ? (
              <table className="contacts-table" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                <thead>
                  <tr style={{ backgroundColor: '#dc3545', color: 'white', textAlign: 'left' }}>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Name</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Mobile</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Address</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Issue</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Date</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Status</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Remarks</th>
                    <th style={{ padding: '12px', border: '1px solid #ddd' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((complaint, index) => {
                    const uniqueId = complaint.id || complaint._id || complaint.uniqueId || `row-${indexOfFirstItem + index}`;
                    const edited = editedComplaints[uniqueId] || {};
                    const currentStatus = edited.status !== undefined ? edited.status : (complaint.status || 'pending');
                    const currentRemarks = edited.remarks !== undefined ? edited.remarks : (complaint.remarks || '');
                    
                    const isModified = 
                      (edited.status !== undefined && edited.status !== (complaint.status || 'pending')) ||
                      (edited.remarks !== undefined && edited.remarks !== (complaint.remarks || ''));

                    return (
                      <tr key={uniqueId} style={{ borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{complaint.name}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{complaint.mobile}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{complaint.address || ''}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>{complaint.issue}</td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                          {complaint.date || ''}
                        </td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                          <select 
                            value={currentStatus}
                            onChange={(e) => handleEditChange(uniqueId, 'status', e.target.value)}
                            style={{ 
                              padding: '6px', 
                              borderRadius: '4px', 
                              border: '1px solid #ddd',
                              backgroundColor: (currentStatus === 'resolved') ? '#d4edda' : '#fff3cd',
                              color: (currentStatus === 'resolved') ? '#155724' : '#856404'
                            }}
                          >
                            <option value="pending">Pending</option>
                            <option value="resolved">Resolved</option>
                          </select>
                        </td>
                        <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                          <input 
                            type="text"
                            value={currentRemarks}
                            onChange={(e) => handleEditChange(uniqueId, 'remarks', e.target.value)}
                            style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}
                            placeholder="Add remarks..."
                          />
                        </td>
                        <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>
                          <button 
                            onClick={() => handleSaveComplaint(complaint, uniqueId)}
                            disabled={!isModified}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: isModified ? '#28a745' : '#ccc',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: isModified ? 'pointer' : 'not-allowed'
                            }}
                          >
                            Save
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              ) : (
                <p>{complaintSearchMobile ? 'No complaints found for this search.' : 'No complaints received yet.'}</p>
              )
            ) : (
              <p>No complaints received yet.</p>
            )}
          </>
        )}

        {totalPages > 1 && (
          <div className="pagination-controls" style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <span style={{ marginRight: '1rem' }}>Page {currentPage} of {totalPages}</span>
            <button onClick={handlePrev} disabled={currentPage === 1} style={currentPage === 1 ? disabledButtonStyle : paginationButtonStyle}>Previous</button>
            <button onClick={handleNext} disabled={currentPage === totalPages} style={currentPage === totalPages ? disabledButtonStyle : paginationButtonStyle}>Next</button>
          </div>
        )}
      </main>
    </div>
  );
};

function App() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isComplaintModalOpen, setIsComplaintModalOpen] = useState(false);
  const [complaintFormData, setComplaintFormData] = useState({
    name: '',
    mobile: '',
    address: '',
    issue: ''
  });
  const [loginFormData, setLoginFormData] = useState({
    username: '',
    password: ''
  });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [jwtToken, setJwtToken] = useState('');
  const [contacts, setContacts] = useState([]);
  const [complaints, setComplaints] = useState([]);
  const [contactFormData, setContactFormData] = useState({
    name: '',
    mobile: '',
    address: '',
    city: '',
    roofType: ''
  });
  const [contactStatus, setContactStatus] = useState(null);
  const [complaintStatus, setComplaintStatus] = useState(null);
  const [loginStatus, setLoginStatus] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Das Enterprises";
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = logo;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % solarImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const fetchContacts = async (tokenOverride) => {
    const tokenToUse = tokenOverride || jwtToken;
    if (!tokenToUse) {
      console.error('Cannot fetch contacts: JWT token is missing.');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/contacts`, {
        headers: {
          Authorization: tokenToUse,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setContacts(data);
      } else {
        console.error('Failed to fetch contacts');
      }
    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  };

  const fetchComplaints = async (tokenOverride) => {
    const tokenToUse = tokenOverride || jwtToken;
    if (!tokenToUse) {
      console.error('Cannot fetch complaints: JWT token is missing.');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/all-complaints`, {
        headers: {
          Authorization: tokenToUse,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setComplaints(data);
      } else {
        console.error('Failed to fetch complaints');
      }
    } catch (error) {
      console.error('Error fetching complaints:', error);
    }
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleComplaintSubmit = async (e) => {
    e.preventDefault();
    setComplaintStatus({ type: 'info', text: 'Submitting complaint...' });

    try {
      const response = await fetch(`${API_BASE_URL}/api/complaints`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(complaintFormData),
      });

      let responseMessage = 'Submission failed. Please try again.';
      try {
        const textResult = await response.text();
        try {
          const jsonResult = JSON.parse(textResult);
          responseMessage = jsonResult.message || textResult;
        } catch (e) {
          responseMessage = textResult || responseMessage;
        }
      } catch (parseError) {
        // Ignore parse error, fallback to generic message
      }

      if (response.ok) {
        if (responseMessage.toLowerCase().includes('already')) {
          setComplaintStatus({ type: 'warning', text: responseMessage });
        } else {
          setComplaintStatus({ type: 'success', text: responseMessage });
          setComplaintFormData({ name: '', mobile: '', address: '', issue: '' });
          setTimeout(() => {
            setIsComplaintModalOpen(false);
            setComplaintStatus(null);
          }, 3000);
        }
      } else {
        const isWarning = responseMessage.toLowerCase().includes('already');
        setComplaintStatus({ type: isWarning ? 'warning' : 'error', text: responseMessage });
      }
    } catch (error) {
      console.error('Complaint error:', error);
      setComplaintStatus({ type: 'error', text: 'Could not connect to the server.' });
    }
  };

  const handleComplaintChange = (e) => {
    const { name, value } = e.target;
    setComplaintFormData({
      ...complaintFormData,
      [name]: name === 'mobile' ? value.replace(/\D/g, '') : value
    });
  };

  const handleLoginChange = (e) => {
    setLoginFormData({
      ...loginFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoginStatus({ type: 'info', text: 'Logging in...' });
    setJwtToken('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: loginFormData.username,
          password: loginFormData.password
        }),
      });

      const rawResponse = await response.text();
      let parsedJson = null;
      try {
        parsedJson = JSON.parse(rawResponse);
      } catch (parseError) {
        parsedJson = null;
      }

      const token = (parsedJson && (parsedJson.token || parsedJson.jwt || parsedJson.accessToken))
        ? String(parsedJson.token || parsedJson.jwt || parsedJson.accessToken).trim()
        : String(rawResponse || '').trim();

      const loginSuccess = parsedJson ? !!parsedJson.status : !!token;

      if (response.ok && loginSuccess && token) {
        setLoginStatus({ type: 'success', text: 'Login Successful!' });
        setJwtToken(token);
        setIsLoggedIn(true);
        setLoggedInUser(loginFormData.username);
        fetchContacts(token);
        fetchComplaints(token);
        setTimeout(() => {
          setIsLoginModalOpen(false);
          setLoginStatus(null);
          navigate('/admin');
        }, 1000);
      } else {
        const errorMessage = parsedJson?.message || 'Invalid credentials or token not received.';
        setLoginStatus({ type: 'error', text: errorMessage });
      }
    } catch (error) {
      console.error('Login error:', error);
      setLoginStatus({ type: 'error', text: 'Could not connect to server.' });
    }
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactFormData({
      ...contactFormData,
      [name]: name === 'mobile' ? value.replace(/\D/g, '') : value
    });
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactStatus({ type: 'info', text: 'Submitting...' });
    try {
      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(contactFormData),
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status) {
          setContactStatus({ type: 'success', text: 'Thank you! We will call you back shortly.' });
          setContactFormData({ name: '', mobile: '', address: '', city: '', roofType: '' });
        } else {
          setContactStatus({ type: 'error', text: result.message || 'Submission failed.' });
        }
      } else {
        setContactStatus({ type: 'error', text: 'Server error. Please try again.' });
      }
    } catch (error) {
      console.error('Contact form submission error:', error);
      setContactStatus({ type: 'error', text: 'Connection failed. Please check your internet.' });
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setLoggedInUser(null);
    setJwtToken('');
    navigate('/');
  };

  const isComplaintFormValid = complaintFormData.name.trim() !== '' && 
                               /^\d{10}$/.test(complaintFormData.mobile.trim()) && 
                               complaintFormData.address.trim() !== '' && 
                               complaintFormData.issue.trim() !== '';

  return (
    <>
      <style>{`
        .spinner-button {
          display: inline-block;
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: #fff;
          animation: spin 1s ease-in-out infinite;
          vertical-align: middle;
        }
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        .blink-text-red {
          color: red;
          font-weight: bold;
          white-space: nowrap;
          animation: textBlink 1s infinite alternate;
        }
        @keyframes textBlink {
          0% { opacity: 1; }
          100% { opacity: 0.2; }
        }
      `}</style>
    <Routes>
      <Route path="/admin" element={
        isLoggedIn
          ? <AdminPage contacts={contacts} complaints={complaints} onLogout={handleLogout} fetchContacts={fetchContacts} fetchComplaints={fetchComplaints} loggedInUser={loggedInUser} onOpenComplaintModal={() => setIsComplaintModalOpen(true)} />
          : <Navigate to="/" />
      } />
      <Route path="/generate-quotation" element={
        isLoggedIn
          ? <GenerateQuotation onLogout={handleLogout} loggedInUser={loggedInUser} />
          : <Navigate to="/" />
      } />
      <Route path="/*" element={
        <div className="app-container">
          {/* Ambient Background Effects */}
          <div className="glow-effect glow-1"></div>
          <div className="glow-effect glow-2"></div>

          <nav className="navbar" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url(${homeIcon})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="nav-content">
          <div className="logo-container">
            <div className="nav-brand">
              <h1>Das Enterprises</h1>
              <span className="authorized-badge">📍 Tudigadia, Soro, Balasore, Odisha-756047</span>
              <span className="authorized-badge">📞 Call Us: +91-9853578030</span>
            </div>
          </div>
          <div className="menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
          <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
            <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); setIsMobileMenuOpen(false); }}>Home</a>
            <a href="#benefits" onClick={(e) => { e.preventDefault(); scrollToSection('benefits'); }}>Benefits</a>
            <a href="#process" onClick={(e) => { e.preventDefault(); scrollToSection('process'); }}>Process</a>
            <a href="#login" onClick={(e) => { e.preventDefault(); setIsLoginModalOpen(true); setIsMobileMenuOpen(false); }}>Login</a>
            <a href="#complaints" onClick={(e) => { e.preventDefault(); setIsComplaintModalOpen(true); setIsMobileMenuOpen(false); }} style={{ color: '#ff4d4d', fontWeight: 'bold' }}>Register Complaint</a>
            <button className="nav-btn" onClick={() => { scrollToSection('contact'); setIsMobileMenuOpen(false); }}>Request Callback</button>
          </div>
        </div>
      </nav>

      <main>
        <section id="home" className="hero-section">
          <div className="hero-content">
            <div className="badge-container" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
              <span className="highlight-badge">Govt Subsidy up to ₹1,38,000/-</span>
              <span className="highlight-badge blink-text-red" style={{ backgroundColor: '#fee2e2', border: '1px solid #fca5a5' }}>Customer Care: 06788 222 999</span>
            </div>
            <h2 className="hero-title">
              Power Your Home with <span className="gradient-text">Free Solar Energy</span>
            </h2>
            <p className="hero-description">
              Transform your roof into a power plant. Get subsidy up to <strong>₹1,38,000/-</strong> directly in your bank account. Zero electricity bills, lifetime savings.
            </p>
            <div className="hero-buttons">
              <button className="cta-btn primary" onClick={() => scrollToSection('contact')}>
                Get Quote
              </button>
              <button className="cta-btn secondary" onClick={() => scrollToSection('process')}>
                How it Works
              </button>
            </div>
            <div className="trust-markers">
              <span>✓ Up to 30 Years Warranty*</span>
              <span>✓ Govt. Subsidy up to ₹1,38,000/-*</span>
            </div>
          </div>
          <div className="hero-image-wrapper">
            <div className="image-card">
              <div className="hero-slider">
                {solarImages.map((img, index) => (
                  <img 
                    key={index}
                    src={img} 
                    alt={`Solar Panel ${index + 1}`} 
                    className={`hero-slide-img ${index === currentImageIndex ? 'active' : ''}`} 
                  />
                ))}
              </div>
              <div className="floating-card subsidy-card">
                <span className="label">Govt. Subsidy</span>
                <span className="value">₹1,38,000*</span>
              </div>
              <div className="floating-card savings-card">
                <span className="label">Yearly Savings</span>
                <span className="value">₹50,000+</span>
              </div>
            </div>
          </div>
        </section>

        <section className="stats-bar">
          <div className="stat-item">
            <span className="stat-number">500+</span>
            <span className="stat-label">Happy Homes</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">2MW+</span>
            <span className="stat-label">Power Installed</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">₹5Cr+</span>
            <span className="stat-label">Subsidy Processed</span>
          </div>
        </section>

        <section id="benefits" className="features-section">
          <div className="section-header">
            <span className="section-tag">Why Choose Solar?</span>
            <h3>Benefits that shine bright</h3>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="icon-box">💰</div>
              <h3>Max Subsidy</h3>
              <p>Get up to ₹1,38,000/- subsidy directly in your bank account via DBT within 60 days.</p>
            </div>
            <div className="feature-card">
              <div className="icon-box">⚡</div>
              <h3>Zero Bills</h3>
              <p>Generate your own electricity. Sell excess power back to the grid in future and earn money.</p>
            </div>
            <div className="feature-card">
              <div className="icon-box">🛠️</div>
              <h3>30 Years Warranty*</h3>
              <p>Performance warranty on solar panels ensuring long-term peace of mind.</p>
            </div>
            <div className="feature-card">
              <div className="icon-box">🏦</div>
              <h3>Easy Finance</h3>
              <p>Low-interest loans available from nationalized banks specifically for solar.</p>
            </div>
            <div className="feature-card">
              <div className="icon-box">🛡️</div>
              <h3>Free Insurance</h3>
              <p>Comprehensive insurance coverage for your solar installation against natural disasters and theft.</p>
            </div>
          </div>
        </section>

        <section id="process" className="process-section">
          <div className="section-header">
            <span className="section-tag">Simple Process</span>
            <h3>Go Solar in 4 Easy Steps</h3>
          </div>
          <div className="process-steps">
            <div className="step-card">
              <div className="step-number">01</div>
              <h4>Site Survey</h4>
              <p>Our engineers visit your home to analyze roof space and shadow area.</p>
            </div>
            <div className="step-card">
              <div className="step-number">02</div>
              <h4>Design & Install</h4>
              <p>Customized structure design and quick installation within 3-4 days.</p>
            </div>
            <div className="step-card">
              <div className="step-number">03</div>
              <h4>Net Metering</h4>
              <p>We handle all government paperwork for net-meter installation.</p>
            </div>
            <div className="step-card">
              <div className="step-number">04</div>
              <h4>Subsidy Release</h4>
              <p>Get subsidy directly in your account after commissioning.</p>
            </div>
          </div>
        </section>

        <section id="contact" className="contact-section">
          <div className="contact-container">
            <div className="contact-info">
              <h3>Ready to switch?</h3>
              <p>Get a free quote and site feasibility report today.</p>
              <div className="info-item">
                <strong>📞 Call Us:</strong> +91 9853578030
              </div>
              <div className="info-item">
                <strong>📧 Email:</strong> sportsboymukesh@gmail.com
              </div>
              <div className="info-item">
                <strong>📍 Visit:</strong> Tudigadia, Soro, Balasore, Odisha-756047
              </div>
            </div>
            <form className="contact-form" onSubmit={handleContactSubmit}>
              <h4>Request Callback</h4>
              <div className="form-group">
                <input type="text" name="name" placeholder="Your Name" required value={contactFormData.name} onChange={handleContactChange} />
              </div>
              <div className="form-group">
                <input type="tel" name="mobile" placeholder="Mobile Number" required value={contactFormData.mobile} onChange={handleContactChange} maxLength="10" pattern="\d{10}" title="Please enter exactly 10 digits" />
              </div>
              <div className="form-group">
                <input type="text" name="address" placeholder="Address (Max 50 chars)" required value={contactFormData.address} onChange={handleContactChange} maxLength="50" />
              </div>
              <div className="form-group">
                <input type="text" name="city" placeholder="City / District" required value={contactFormData.city} onChange={handleContactChange} />
              </div>
              <div className="form-group">
                <select name="roofType" required value={contactFormData.roofType} onChange={handleContactChange}>
                  <option value="" disabled>Select Roof Type</option>
                  <option value="Concrete Flat Roof">Concrete Flat Roof</option>
                  <option value="Tin Shed">Tin Shed</option>
                  <option value="Tiled Roof">Tiled Roof</option>
                </select>
              </div>
              <button type="submit" className="submit-btn" disabled={contactStatus?.type === 'info'}>
                {contactStatus?.type === 'info' ? <div className="spinner-button" /> : 'Get Free Quote'}
              </button>
              {contactStatus && contactStatus.type !== 'info' && (
                <div style={{
                  marginTop: '15px',
                  padding: '10px',
                  borderRadius: '5px',
                  backgroundColor: contactStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                  color: contactStatus.type === 'success' ? '#155724' : '#721c24',
                  textAlign: 'center',
                  fontSize: '0.9rem'
                }}>
                  {contactStatus.text}
                </div>
              )}
            </form>
          </div>
        </section>  
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <h4>Das Enterprises</h4>
            <p>Empowering India with Solar Energy.</p>
          </div>
          <div className="footer-links">
            <a href="#home">Home</a>
            <a href="#benefits">Benefits</a>
            <a href="#contact">Contact</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Das Enterprises. All rights reserved.</p>
        </div>
      </footer>

      <a href="tel:+919853578030" className="floating-call-btn">
        📞 +91 9853578030
      </a>

      {/* Login Modal */}
      {isLoginModalOpen && (
        <div className="modal-overlay" onClick={(e) => { if(e.target.className === 'modal-overlay') setIsLoginModalOpen(false); }}>
          <div className="modal-content">
            <span className="close-modal" onClick={() => setIsLoginModalOpen(false)}>&times;</span>
            <div className="modal-header">
              <h2>Welcome Back</h2>
              <p>Please login to your account</p>
            </div>
            <form className="login-form" onSubmit={handleLoginSubmit}>
              <div className="form-group">
                <label>User ID</label>
                <input 
                  type="text" 
                  name="username" 
                  placeholder="Enter your User ID" 
                  required 
                  value={loginFormData.username}
                  onChange={handleLoginChange}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input 
                  type="password" 
                  name="password" 
                  placeholder="Enter your password" 
                  required 
                  value={loginFormData.password}
                  onChange={handleLoginChange}
                />
              </div>
              <div className="form-actions">
                <label className="checkbox-container">
                  <input type="checkbox" /> Remember me
                </label>
                <a href="#forgot" className="forgot-password">Forgot Password?</a>
              </div>
              <button type="submit" className="submit-btn" disabled={loginStatus?.type === 'info'}>
                {loginStatus?.type === 'info' ? <div className="spinner-button" /> : 'Login'}
              </button>
              {loginStatus && loginStatus.type !== 'info' && (
                <div style={{
                  marginTop: '15px',
                  padding: '10px',
                  borderRadius: '5px',
                  backgroundColor: loginStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                  color: loginStatus.type === 'success' ? '#155724' : '#721c24',
                  textAlign: 'center',
                  fontSize: '0.9rem'
                }}>
                  {loginStatus.text}
                </div>
              )}
              <p className="signup-link">
                Need to report an issue? <a href="#complaints" onClick={(e) => { e.preventDefault(); setIsLoginModalOpen(false); setIsComplaintModalOpen(true); }} style={{ color: '#ff4d4d', fontWeight: 'bold' }}>Register Complaint</a>
              </p>
            </form>
          </div>
        </div>
      )}

        </div>
      } />
    </Routes>

    {isComplaintModalOpen && (
      <div className="modal-overlay" onClick={(e) => { if(e.target.className === 'modal-overlay') setIsComplaintModalOpen(false); }}>
        <div className="modal-content">
          <span className="close-modal" onClick={() => setIsComplaintModalOpen(false)}>&times;</span>
          <div className="modal-header">
            <h2>Register Complaint</h2>
            <p>Let us know your issue, we will resolve it soon.</p>
          </div>
          <form className="login-form" onSubmit={handleComplaintSubmit}>
            <div className="form-group">
              <input 
                type="text" 
                name="name" 
                placeholder="Enter your name" 
                required 
                value={complaintFormData.name}
                onChange={handleComplaintChange}
              />
            </div>
            <div className="form-group">
              <input 
                type="text" 
                name="address" 
                placeholder="Enter your address" 
                required 
                value={complaintFormData.address}
                onChange={handleComplaintChange}
              />
            </div>
            <div className="form-group">
              <input 
                type="tel" 
                name="mobile" 
                placeholder="Mobile Number" 
                required 
                value={complaintFormData.mobile}
                onChange={handleComplaintChange}
                maxLength="10" 
                pattern="\d{10}" 
                title="Please enter exactly 10 digits"
              />
            </div>
            <div className="form-group">
              <textarea 
                name="issue" 
                placeholder="Describe your issue (Max 100 characters)" 
                required 
                value={complaintFormData.issue}
                onChange={handleComplaintChange}
                rows="4"
                maxLength="100"
                style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', resize: 'none', boxSizing: 'border-box' }}
              />
              <div style={{ textAlign: 'right', fontSize: '0.8rem', color: '#666', marginTop: '4px' }}>
                {complaintFormData.issue.length}/100
              </div>
            </div>
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={complaintStatus?.type === 'info' || !isComplaintFormValid}
              style={{
                cursor: (isComplaintFormValid && complaintStatus?.type !== 'info') ? 'pointer' : 'not-allowed',
                opacity: (isComplaintFormValid && complaintStatus?.type !== 'info') ? 1 : 0.6
              }}
            >
              {complaintStatus?.type === 'info' ? <div className="spinner-button" /> : 'Submit Complaint'}
            </button>
            {complaintStatus && complaintStatus.type !== 'info' && (
              <div style={{
                marginTop: '15px',
                padding: '10px',
                borderRadius: '5px',
                backgroundColor: complaintStatus.type === 'success' ? '#d4edda' : 
                                 complaintStatus.type === 'warning' ? '#fff3cd' : '#f8d7da',
                color: complaintStatus.type === 'success' ? '#155724' : 
                       complaintStatus.type === 'warning' ? '#856404' : '#721c24',
                textAlign: 'center',
                fontSize: '0.9rem'
              }}>
                {complaintStatus.text}
              </div>
            )}
          </form>
        </div>
      </div>
    )}
    </>
  );
}

export default App;
